<template>
  <div
    class="card-program"
    @click="handleClick"
  >
    <div class="overlay-container">
      <img
        :src="programData.avatar && !isBrokenImage ? `${urlServerImage}/303x202,fit/${programData.avatar}` : defaultImage"
        :alt="`${programData.name} | Sekolah.mu`"
        @error="isBrokenImage = true"
        class="card-image"
        loading="lazy"
        width="303"
        height="202"
        :class="{'overlay-image': (programData.group.length && !programData.is_joined) || (programData.max_quota && !programData.current_quota)}"
      >
      <div
        class="overlay"
        v-if="(programData.group.length && !programData.is_joined) || (programData.max_quota && !programData.current_quota)"
      >
        <div class="overlay-text open-sans font-weight-bold">
          {{programData.max_quota && !programData.current_quota ? 'KUOTA HABIS' : 'TERBATAS'}}
        </div>
      </div>
    </div>
    <div class="card-right">
      <div class="informasi">
        <div
          class="badge-card"
          v-if="programData.tag.length !== 0"
        >
          <button
            class="mr-1"
            v-for="data in firstThreeTag(programData.tag)"
            :key="data.id"
          >{{data.title}}</button>
        </div>
        <div
          class="badge-card-empty"
          v-else
        >
          <button class="mr-1">Kosong</button>
        </div>
        <div class="card-title">
          {{programData.name}}
        </div>
        <p class="creator-title mt-2">Oleh <span class="creator-name">{{programData.creator ? programData.creator : 'Sekolahmu'}}</span></p>
      </div>
      <div
        class="card-description"
        v-html="sanitizeXSS(cardDescription)"
      ></div>
      <div class="rating">
        <s-rating :length="5" :modelValue="ratingProgram" size="medium" />
        <span class="rating-number">
          {{ ratingProgram }}
        </span>
        <span class="reviewers">
          {{ `(${reviewersProgram})` }}
        </span>
      </div>
      <div class="card-prices">
        <div
          class="discounted-price"
          v-if="programData.group.length"
        >Terbatas</div>
        <div
          class="discounted-price-ikut"
          v-else-if="programData.enrolled && isLogin"
        >Sudah Ikut</div>
        <div
          class="d-flex"
          v-else
        >
          <div class="discounted-price">{{rupiahFormatDiscount(programData.price)}}</div>
          <div class="normal-price">{{rupiahFormatNormal(programData.price_normal)}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import rupiah from '../../functions/rupiah'
import Image from '../../assets/images/programmu/index'

export default {
  name: 'program-card',
  data () {
    return {
      defaultImage: Image.no_cover,
      isMobileDevice: false,
      isBrokenImage: false
    }
  },
  computed: {
    cardDescription () {
      if (this.programData.abstract.length === undefined || this.programData.abstract === null || this.programData.abstract === '') {
        return ''
      } else if (this.programData.abstract.length < 140) {
        return this.programData.abstract
      } else {
        return this.programData.abstract.slice(0, 140)
      }
    },
    urlServerImage () {
      return process.env.VUE_APP_URL_SERVER_IMAGE
    },
    ratingProgram () {
      return Number(this.programData.rating || 0)
    },
    reviewersProgram () {
      return Number(this.programData.reviewers || 0)
    },
    isLogin () {
      return this.$store.state.user.isLogin
    }
  },
  methods: {
    sanitizeXSS (htmlEmbed) {
      return this.$XSSFilter(htmlEmbed)
    },
    handleClick (event) {
      event.preventDefault()
      // this.validateProgram() // uncomment this line if you want to validate program
      const route = this.toDetail(this.programData.slug ? this.programData.slug : this.programData.id)
      this.$router.push(route)
    },
    // validateProgram () {
      // if (this.programData.group.length && !this.programData.is_joined) {
      //   let selected = null
      //   if ((this.programData.slug || this.programData.id) && this.programData.group.length) {
      //     selected = this.programData.slug || this.programData.id
      //   }
      //   this.$store.commit('program/CHANGE_OPEN_PROGRAM_TERBATAS', { isOpen: true, selected })
      // }
    // },
    firstThreeTag (item) {
      if (this.isMobileDevice) {
        if (item.length <= 2) {
          return item
        } else {
          const newItem = item.slice(0, 2)
          return newItem
        }
      } else {
        if (item.length <= 3) {
          return item
        } else {
          const newItem = item.slice(0, 3)
          return newItem
        }
      }
    },
    toDetail (id) {
      // DEFINE REFERAL
      let pageRef
      if (this.$route.params.project) {
        pageRef = this.$route.params.project ? this.$route.params.project : ''
      } else if (this.$route.params.institution_slug) {
        pageRef = this.$route.params.institution_slug ? this.$route.params.institution_slug : ''
      } else {
        pageRef = ''
      }

      const queryRef = this.$route.query.ref ? this.$route.query.ref : ''

      if (pageRef && queryRef) {
        return `/program/${id}?ref=${pageRef}_${queryRef}`
      } else if (pageRef) {
        return `/program/${id}?ref=${pageRef}`
      } else {
        return `/program/${id}`
      }
    },
    rupiahFormatDiscount (nominal) {
      if (Number(nominal) === 0) {
        return 'GRATIS'
      } else if (Number(nominal) === 0 && Number(this.programData.price_normal) !== 0) {
        return rupiah(Number(nominal))
      } else {
        return rupiah(Number(nominal))
      }
    },
    rupiahFormatNormal (nominal) {
      if (Number(nominal) === 0 && Number(this.programData.price) >= 0) {
        return ''
      } else {
        return rupiah(Number(nominal))
      }
    }
  },
  props: {
    programData: Object
  },
  created () {
    if (window.innerWidth <= 820) {
      this.isMobileDevice = true
    }
  }
}
</script>

<style scoped>
a {
  text-decoration: none;
  color: inherit;
  /* display: flex; */
  /* align-items: stretch; */
  /* align-content: stretch; */
}
p {
  margin-bottom: 0px;
}

.overlay-container {
  position: relative;
}

.overlay-image {
  display: block;
  width: 100%;
  height: auto;
}

.overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.39);
  border-radius: 5px 5px 0 0;
}

.overlay-text {
  font-size: 22px;
  line-height: 14px;
  display: flex;
  align-items: center;
  color: #ffffff;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  text-align: center;
}

.card-program {
  text-decoration: none;
  color: inherit;
  min-width: 325px;
  max-width: 325px;
  background: var(--color-neutral-100);
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  position: relative;
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  margin-left: 10px;
  margin-right: 10px;
  border-radius: 5px;
  transition: 0.2s;
  cursor: pointer;
}

.card-image {
  margin: 11px 11px 0 11px;
  min-width: 303px;
  max-width: 303px;
  min-height: 202px;
  max-height: 202px;
}

.card-program:hover {
  cursor: pointer;
  box-shadow: 0px 12px 12px rgba(0, 0, 0, 0.25);
}

.banner-card {
  position: absolute;
  margin-left: -11px;
}

.banner-card-body {
  width: 84px;
  height: 25px;
  position: relative;
  background: #ffc426;
  font-size: 10px;
  color: #172d5c;
  font-weight: 700;
  display: flex;
  align-items: center;
  padding-left: 11px;
}

.banner-card-body:before {
  content: "";
  position: absolute;
  right: -12.5px;
  bottom: 0;
  width: 0;
  height: 0;
  border-left: 12.5px solid #ffc426;
  border-top: 12.5px solid transparent;
  border-bottom: 12.5px solid transparent;
}

.card-right {
  padding: 0 14px 11px 14px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  /* overflow: hidden; */
}

.badge-card {
  margin-top: 8px;
}

.badge-card button {
  background-color: rgba(255,196,38,.5);
  border-radius: 20px;
  color: #082947;
  border: none;
  font-size: 11px;
  padding-left: 15px;
  padding-right: 15px;
}

.badge-card-empty {
  margin-top: 8px;
}

.badge-card-empty button {
  background-color: #ffffff;
  border-radius: 20px;
  color: #ffffff;
  border: none;
  font-size: 11px;
  padding-left: 15px;
  padding-right: 15px;
}

.card-title {
  font-size: 16px;
  margin-top: 10px;
  font-weight: 600;
}

.card-description {
  color: rgba(0,0,0,.7);
  font-size: 12px;
  max-width: 100%;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  word-break: break-word;
  word-spacing: normal;
  margin-top: 10px;
  display: flex;

  /* overflow-y: scroll; */
  /* padding-right: 2%;
  box-sizing: content-box; */
}

.card-prices {
  display: flex;
  align-items: flex-end;
  margin-top: 10px;
}

.discounted-price {
  /* font-family: "hind_guntursemibold"; */
  color: #3498db;
  font-weight: 600;
  font-size: 16px;
  line-height: 16px;
}

.discounted-price-ikut {
  /* font-family: "hind_guntursemibold"; */
  color: #ffc429;
  font-weight: 600;
  font-size: 16px;
  line-height: 16px;
}

.normal-price {
  /* font-family: "hind_guntursemibold"; */
  margin-left: 9px;
  font-size: 10px;
  color: rgba(0, 0, 0, 0.3);
  text-decoration-line: line-through;
}

.creator-title {
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  color: rgba(0,0,0,.5);
}

.creator-name {
  font-style: normal;
  font-weight: 700;
  font-size: 13px;
  color: #828282;
}

.rating {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.rating-number,
.reviewers {
  font-size: 14px;
  height: 14px;
  margin-left: 3px;
  color: #828282;
}

/* @media screen and (max-width: 820px) {
  .card-program {
    min-width: 160px;
    max-width: 160px;
    background: #ffffff;
    padding: 7px 5px;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    position: relative;
    display: flex;
    flex-direction: column;
    margin-top: 10px;
    margin-left: 5px;
    margin-right: 5px;
    border-radius: 2px;
    transition: 0.2s;
  }

  .card-image{
    min-width: 150px;
    max-width: 150px;
    min-height: 100px;
    max-height: 100px;
  }

  .badge-card {
    margin-top: 8px;
    min-height: 25px;
  }

  .badge-card-empty {
    margin-top: 8px;
    min-height: 25px;
  }

  .card-title {
    font-size: 14px;
    margin-top: 10px;
    font-weight: 600;
  }

  .card-description {
    color: rgba(0, 0, 0, 0.7);
    font-size: 12px;
    margin-top: 10px;
    max-width: 100%;
    word-break: break-word;
    word-spacing: normal;

    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }

  .discounted-price {
    color: #3498DB;
    font-weight: 600;
    font-size: 13px;
    line-height: 13px;
  }

  .discounted-price-ikut {
    color: #FFC429;
    font-weight: 600;
    font-size: 13px;
    line-height: 13px;
  }
} */

@media screen and (max-width: 375px) {
  .card-program {
    margin: 10px 0px;
    min-width: 300px;
    max-width: 300px;
  }

  .card-image {
    min-width: 278px;
    max-width: 278px;
    min-height: 175px;
    max-height: 175px;
  }
}

@media screen and (max-width: 325px) {
  .card-program {
    margin: 10px 0px;
    min-width: 250px;
    max-width: 250px;
  }

  .card-image {
    min-width: 228px;
    max-width: 228px;
    min-height: 150px;
    max-height: 150px;
  }
}
</style>
